var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6701 6.35025C19.8462 5.86489 18.8239 5.86489 18.0001 6.35025L14.0001 8.65025C13.9982 7.6983 13.4897 6.81934 12.6653 6.34327C11.841 5.86721 10.8255 5.86606 10.0001 6.34025L3.33007 10.1902C2.5062 10.6678 1.99902 11.548 1.99902 12.5002C1.99902 13.4525 2.5062 14.3327 3.33007 14.8102L10.0001 18.6602C10.8256 19.1393 11.8445 19.1393 12.6701 18.6602C13.4966 18.1855 14.0044 17.3034 14.0001 16.3502L18.0001 18.6602C18.4046 18.8937 18.863 19.0177 19.3301 19.0202C19.802 19.0203 20.2651 18.8925 20.6701 18.6502C21.4965 18.1803 22.005 17.301 22.0001 16.3502V8.65025C22.005 7.69954 21.4965 6.82017 20.6701 6.35025ZM12.0001 16.3505C12.0031 16.5893 11.8769 16.8111 11.6701 16.9305C11.4617 17.0462 11.2084 17.0462 11.0001 16.9305L4.33006 13.0805C4.12299 12.9607 3.99547 12.7397 3.99547 12.5005C3.99547 12.2613 4.12299 12.0402 4.33006 11.9205L11.0001 8.07048C11.2074 7.95079 11.4628 7.95079 11.6701 8.07048C11.8769 8.18987 12.0031 8.41168 12.0001 8.65048V16.3505ZM20.0001 16.3501C19.9955 16.5861 19.867 16.8023 19.662 16.9192C19.4569 17.0361 19.2055 17.0365 19.0001 16.9201L14.0001 14.0401V10.9601L19.0001 8.08015C19.2055 7.96384 19.4569 7.9642 19.662 8.08109C19.867 8.19798 19.9955 8.41415 20.0001 8.65015V16.3501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPrev);
export default __webpack_public_path__ + "static/media/play-prev.7257ef18.svg";
export { ForwardRef as ReactComponent };